import Reflux from 'reflux';
import EventData from 'shared/data/Event';

let async = { asyncResult: true },
  EventActions = Reflux.createActions({
    updateField: async,
    updatePhoto: async,
  });

EventActions.updateField.listenAndPromise((teamId, eventId, field, value) => {
  let changes = {};
  changes[field] = value;
  return EventData.update(teamId, eventId, changes);
});

EventActions.updatePhoto.listenAndPromise(EventData.updatePhoto);

export default EventActions;
